import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { user, refresh } = useAuth();
  const [state, setState] = useState(token ? { status: "loading" } : { status: "error", message: "Link non valido: manca il codice di conferma." });
  // The token is single-use: a second request (React StrictMode runs effects twice) would report it as already used.
  const sent = useRef(false);

  useEffect(() => {
    if (!token || sent.current) return;
    sent.current = true;
    api.post("/auth/verify-email", { token })
      .then(() => { setState({ status: "ok" }); refresh(); })
      .catch((e) => setState({ status: "error", message: formatApiError(e.response?.data?.detail) }));
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const home = user ? (user.role === "supplier" ? "/fornitore" : "/ristorante") : "/login";
  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="ga-card p-8" data-testid="verify-email-card">
        <div className="text-xs font-mono uppercase tracking-widest text-slate-500">Conferma email</div>
        {state.status === "loading" && <div className="mt-4 text-sm text-slate-600">Verifica in corso...</div>}
        {state.status === "ok" && (
          <div className="mt-4" data-testid="verify-email-ok">
            <h1 className="font-display text-3xl font-extrabold text-slate-900 flex items-center gap-2"><CheckCircle2 className="w-7 h-7 text-emerald-600" /> Email confermata</h1>
            <p className="mt-3 text-sm text-slate-600">Grazie! Se la tua azienda è già verificata puoi iniziare subito; altrimenti ti avvisiamo via email appena l'amministratore approva l'account.</p>
          </div>
        )}
        {state.status === "error" && (
          <div className="mt-4" data-testid="verify-email-error">
            <h1 className="font-display text-3xl font-extrabold text-slate-900 flex items-center gap-2"><XCircle className="w-7 h-7 text-red-600" /> Link non valido</h1>
            <p className="mt-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl p-3">{state.message}</p>
          </div>
        )}
        <p className="mt-6 text-sm text-slate-600"><Link to={home} className="font-semibold text-slate-900 hover:underline">{user ? "Vai alla dashboard →" : "Accedi →"}</Link></p>
      </div>
    </div>
  );
}
